module.exports = require('./helpers/bundle-url').getBundleURL('drLhz') + "../assets/images/logo.43d8ec18.png";